export default class {
  constructor(context) {
    // Set Context
    this._context = context;

    // Initialise component
    this.init();
  }

  init() {
    // Attach event listeners to each brochure checkbox. This is only run once.
    this._closeButton = document.querySelector('[data-availability="close"]');
    this._openButton = document.querySelector('[data-availability="open"]');
    if (this._closeButton) {
      this._closeButton.addEventListener('click', () => this.closeModal());
    }
    if (this._openButton) {
      this._openButton.addEventListener('click', () => this.openModal());
    }
    // Adjust margin to the size of the fixed availability bar so you can completely see footer
    this.adjustMarginForCheckAvailability();
  }

  adjustMarginForCheckAvailability() {
    const checkAvailability = document.querySelector('.CheckAvailability');
    const footer = document.querySelector('footer'); // Target the footer element specifically
    if (checkAvailability && footer) {
      const height = checkAvailability.offsetHeight;
      footer.style.marginBottom = height + 'px';
    }
  }

  closeModal() {
    this._context.classList.add('hidden');
  }

  openModal() {
    this._context.classList.remove('hidden');
  }
}